// Column keys double as the backend sort keys (CommitteeFilters::SORTABLE).
export function buildColumns() {
  return [
    { key: 'name', label: 'Committee Name', sortable: true, minWidth: '200px', width: '1fr' },
    { key: 'edit', label: 'Edit', width: '70px', cellClass: 'text-center' },
    { key: 'remove', label: 'Remove', width: '80px', cellClass: 'text-center' }
  ]
}

// Below 700px the row collapses into an accordion: the name as summary, Edit/Remove as detail.
export function buildBreakpoints() {
  return [
    {
      maxWidth: 700,
      hideHeader: true,
      accordion: {
        summary: [{ keys: ['name'], hideLabel: true }]
      },
      rows: [
        ['edit'],
        ['remove']
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/Committees/Listing/committeesColumns.js